export const legalDocuments = {
  terms: {
    title: 'Términos y condiciones',
    updatedAt: 'Última actualización: 6 de abril de 2026',
    sections: [
      {
        heading: '1. Quién presta el servicio',
        paragraphs: [
          'Esta aplicación de notas es un producto digital operado por Funda tu sitio web. El servicio está disponible para organización personal y colaboración entre usuarios en hojas compartidas.',
          'Para dudas generales o solicitudes relacionadas con tu cuenta puedes escribir a gabriela.martinez@fundatusitioweb.com o visitar fundatusitioweb.com.'
        ]
      },
      {
        heading: '2. Uso permitido',
        paragraphs: [
          'Puedes usar la aplicación para crear, editar, sincronizar y compartir listas y notas. Te comprometes a no usar el servicio para actividades ilícitas, invasivas, fraudulentas o que afecten el funcionamiento normal de la plataforma.',
          'Cada usuario es responsable del contenido que crea, comparte o elimina dentro de sus hojas personales o grupales.'
        ]
      },
      {
        heading: '3. Cuentas y acceso',
        paragraphs: [
          'Al crear una cuenta debes proporcionar información básica veraz y mantener tus credenciales protegidas. Eres responsable de la actividad realizada desde tu cuenta mientras no reportes un uso no autorizado.',
          'El servicio puede requerir conexión a internet para sincronización, imágenes, invitaciones y funciones colaborativas en tiempo real.'
        ]
      },
      {
        heading: '4. Hojas compartidas y colaboración',
        paragraphs: [
          'Cuando participas en hojas grupales, otros miembros autorizados pueden ver cambios, estados, actividad reciente y notificaciones relacionadas con esas hojas.',
          'Las notificaciones muestran actividad funcional del grupo, por ejemplo altas, ediciones, cambios de estado o movimientos relevantes dentro de una hoja compartida.'
        ]
      },
      {
        heading: '5. Disponibilidad del servicio',
        paragraphs: [
          'Se realizan esfuerzos razonables para mantener el servicio disponible, pero pueden existir mantenimientos, actualizaciones, fallas temporales, limitaciones de terceros o errores fuera de control operativo.',
          'La aplicación puede actualizarse para mejorar seguridad, estabilidad, compatibilidad o experiencia de uso.'
        ]
      },
      {
        heading: '6. Suspensión o cancelación',
        paragraphs: [
          'Podemos limitar o suspender el acceso cuando existan indicios de uso indebido, afectaciones técnicas, incumplimiento de estos términos o requerimientos legales aplicables.',
          'También puedes solicitar la baja de tu cuenta y la atención de solicitudes relacionadas con tus datos por los canales de contacto indicados en este documento y en el aviso de privacidad.'
        ]
      },
      {
        heading: '7. Propiedad intelectual',
        paragraphs: [
          'La interfaz, marca, estructura del servicio, componentes visuales y desarrollos relacionados pertenecen a sus respectivos titulares. El uso del servicio no transfiere derechos de propiedad intelectual al usuario.',
          'Conservas la titularidad del contenido que cargas, con la autorización necesaria para procesarlo técnicamente dentro del servicio.'
        ]
      },
      {
        heading: '8. Limitación de responsabilidad',
        paragraphs: [
          'El servicio se ofrece bajo una base de funcionamiento razonable, pero no se garantiza ausencia absoluta de errores, pérdidas de conectividad, indisponibilidad de terceros o interrupciones no previstas.',
          'En la máxima medida permitida por la ley aplicable, la responsabilidad se limita a los daños directos razonablemente atribuibles al servicio y nunca a expectativas indirectas o pérdidas consecuenciales.'
        ]
      }
    ]
  },
  privacy: {
    title: 'Aviso de privacidad',
    updatedAt: 'Última actualización: 6 de abril de 2026',
    sections: [
      {
        heading: '1. Responsable',
        paragraphs: [
          'Funda tu sitio web es responsable del tratamiento de los datos personales utilizados para operar esta aplicación.',
          'Contacto para privacidad, acceso, corrección, baja o dudas: gabriela.martinez@fundatusitioweb.com.'
        ]
      },
      {
        heading: '2. Datos que pueden tratarse',
        paragraphs: [
          'Dependiendo del uso, pueden tratarse datos como nombre, nombre de usuario, correo electrónico, datos de acceso, identificadores de dispositivo, información técnica de sesión, contenido de notas, imágenes adjuntas y actividad relacionada con hojas compartidas.',
          'En funciones colaborativas también puede procesarse información funcional como membresía de grupo, invitaciones, lecturas de notificaciones y eventos de sincronización entre dispositivos.'
        ]
      },
      {
        heading: '3. Finalidades',
        paragraphs: [
          'Tus datos se usan para crear y administrar cuentas, autenticar sesiones, sincronizar información, habilitar colaboración, mostrar notificaciones, brindar soporte, mejorar estabilidad, atender incidencias y prevenir usos indebidos del servicio.',
          'Cuando corresponda, también pueden utilizarse para mensajes operativos relacionados con seguridad, acceso o funcionamiento de la cuenta.'
        ]
      },
      {
        heading: '4. Transferencias y encargados',
        paragraphs: [
          'Para operar el servicio pueden intervenir proveedores tecnológicos de infraestructura, almacenamiento, correo transaccional, analítica, pagos o servicios de comunicación en tiempo real, únicamente en la medida necesaria para prestar la plataforma.',
          'No se venden datos personales. Cualquier transferencia se realiza bajo la base legal o contractual aplicable al funcionamiento del servicio.'
        ]
      },
      {
        heading: '5. Conservación y seguridad',
        paragraphs: [
          'Se aplican medidas razonables de seguridad administrativas, técnicas y organizativas para proteger la información. Aun así, ningún sistema conectado a internet puede garantizar seguridad absoluta.',
          'Los datos se conservan durante el tiempo necesario para la operación del servicio, cumplimiento de obligaciones aplicables, atención de controversias o solicitudes legítimas del usuario.'
        ]
      },
      {
        heading: '6. Derechos y solicitudes',
        paragraphs: [
          'Puedes solicitar acceso, rectificación, actualización, baja o información sobre el tratamiento de tus datos escribiendo a gabriela.martinez@fundatusitioweb.com.',
          'Para proteger tu cuenta, podríamos pedir información adicional razonable para validar identidad antes de procesar una solicitud.'
        ]
      },
      {
        heading: '7. Cambios al aviso',
        paragraphs: [
          'Este aviso puede actualizarse por cambios operativos, funcionales, legales o de seguridad. Cuando el cambio sea relevante, podrá informarse a través de la aplicación o por medios razonables dentro del servicio.'
        ]
      }
    ]
  }
};
